import { TranslateService } from '@ngx-translate/core';
import { getRouteLanguage } from '@obo-main/utils/staticHelperFunctions';

export function LocaleFactory(translateService: TranslateService) {
    return getRouteLanguage(translateService.currentLang);
}
